// src/components/ProtectedRoute.jsx
import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { useAuth0 } from '@/hooks/useAuth';
import { useAccountStatus } from '@/hooks/useAccountStatus';
import { PageLoader } from '@/components/PageLoader';
import PendingApprovalPage from '@/pages/PendingApprovalPage';

/**
 * Protege as rotas verificando o estado de autenticação unificado.
 * Suporta tanto o fluxo manual (email/senha com tokens no localStorage)
 * quanto o fluxo OAuth via redirect do Auth0 (ex: Google).
 * Depois de autenticado, também exige que a conta esteja aprovada por
 * um administrador (ver useAccountStatus) — cobre login por senha e Google.
 */
export const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuth0();
  const { status, isLoading: statusLoading } = useAccountStatus();

  // Enquanto o Auth0 SDK está verificando a sessão (ex: após redirect do Google),
  // exibimos um loader para evitar redirecionamentos prematuros.
  if (isLoading) {
    return <PageLoader />;
  }

  if (!isAuthenticated) {
    // Se não estiver autenticado, salva a rota que o usuário tentou acessar
    // para redirecionar de volta após o login.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (statusLoading) {
    return <PageLoader />;
  }

  if (status !== 'Aprovado') {
    return (
      <PendingApprovalPage
        rejected={status === 'Rejeitado'}
        outroCondominio={status === 'OutroCondominio'}
      />
    );
  }

  // Se o componente for usado como Wrapper <ProtectedRoute><Home /></ProtectedRoute>
  if (children) {
    return children;
  }

  // Se o componente for usado como Layout <Route element={<ProtectedRoute />} />
  return <Outlet />;
};
